import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import auth from './auth';

export const ProtectedRoute = ({component: Component, ...rest}) => {
    return(
        <Route {...rest} render={
            props => {
                // console.log("Before itting the status is: " + auth.isAuthenticated());
                if(auth.isAuthenticated() === "true"){
                    // console.log("redirectig");
                    return <Component {...props}/>
                } else {
                    // console.log("false redirection");
                    return <Redirect to={ ""
                    }
                    />
                }
            }   
        }/>
    )
}